import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_SIGNUP_DOCUMENT_QUERY_KEY } from './useGetSignupDocumentUrl';
import { GET_USER_BY_ID_QUERY_KEY } from './useGetUser';

type RejectResponse = { status: 'rejected'; userId: string };

export const useRejectSignupDocument = (
    userId: string,
    onSuccess?: () => void,
    onError?: (error: Error) => void,
) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['rejectSignupDocument', userId],
        mutationFn: (body: { reason?: string }) =>
            apiClient.fetchApi<RejectResponse, { reason?: string }>({
                method: 'POST',
                endpoint: `users/${userId}/signup-document/reject`,
                body,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_USER_BY_ID_QUERY_KEY(userId) });
            queryClient.invalidateQueries({ queryKey: GET_SIGNUP_DOCUMENT_QUERY_KEY(userId) });
            onSuccess?.();
        },
        onError,
    });
};
